import { jsxs, jsx } from 'react/jsx-runtime';
import { addPropsToSVG } from '../helpers/add-props-to-svg.esm.js';

const _SocialFacebook = (props)=>jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            jsx("path", {
                fill: "currentColor",
                d: "M22 12.0611c0-5.5566-4.4771-10.0611-10-10.0611s-10 4.5045-10 10.0611c0 5.0218 3.6569 9.1841 8.4375 9.9389v-7.0306h-2.539v-2.9083h2.539v-2.2166c0-2.5215 1.4929-3.9144 3.7771-3.9144 1.0942 0 2.2385.1965 2.2385.1965v2.476h-1.261c-1.2422 0-1.6296.7755-1.6296 1.5712v1.8873h2.7734l-.4433 2.9083h-2.3301v7.0306c4.7807-.7548 8.4375-4.9171 8.4375-9.9389Z",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: props.strokeWidth || 1.5,
                d: "M6.9996 10h.0007",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            }),
            jsx("path", {
                stroke: "currentColor",
                strokeWidth: 2,
                d: "M9 10",
                style: {
                    vectorEffect: 'non-scaling-stroke'
                }
            })
        ]
    });
const SocialFacebook = addPropsToSVG(_SocialFacebook);

export { SocialFacebook };
